import { render, staticRenderFns } from "./articlePool.vue?vue&type=template&id=59ca3202&scoped=true&"
import script from "./articlePool.vue?vue&type=script&lang=js&"
export * from "./articlePool.vue?vue&type=script&lang=js&"
import style0 from "./articlePool.vue?vue&type=style&index=0&id=59ca3202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca3202",
  null
  
)

export default component.exports